import definition from '../config/credit-unit.json' with {type:'json'};

/** RenderRank's redemption unit. The ledger remains exact provider nanodollars. */
export const creditUnit=definition;
const nanousdPerCredit=BigInt(definition.providerNanousdPerCredit);
export function creditsFromNanousd(value:bigint|string):number {return Number(BigInt(value))/Number(nanousdPerCredit);}
export function creditsFromUsd(value:string|number):number {
 const raw=typeof value==='number'?value.toFixed(9):value;
 if(!/^-?\d+(?:\.\d{1,9})?$/.test(raw))throw new Error('Invalid credit value.');
 const negative=raw.startsWith('-'),[whole,fraction='']=(negative?raw.slice(1):raw).split('.');
 return creditsFromNanousd((BigInt(whole!)*1000000000n+BigInt(fraction.padEnd(9,'0')))*(negative?-1n:1n));
}
/** Admin credit grants and plan creation accept hundredths of a credit exactly. */
export function creditAmountToUsd(value:string):string {
 if(!/^(?:0|[1-9][0-9]{0,11})(?:\.[0-9]{1,2})?$/.test(value))throw new Error('Enter credits with at most two decimal places.');
 const [whole,fraction='']=value.split('.'),amount=(BigInt(whole!)*100n+BigInt(fraction.padEnd(2,'0')))*nanousdPerCredit/100n;
 return `${amount/1000000000n}.${(amount%1000000000n).toString().padStart(9,'0')}`;
}
const formatter=new Intl.NumberFormat('en-US',{minimumFractionDigits:0,maximumFractionDigits:definition.displayDecimals});
export function providerUsdFromCredits(value:number):number {return value*Number(nanousdPerCredit)/1e9;}
export function formatCredits(value:string|number):string {return formatter.format(Number(value));}
export function formatUsdAsCredits(value:string|number):string {return formatCredits(creditsFromUsd(value));}
